import { ICheckoutInfo } from '../../types/reducers/checkoutInfo';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHECK_SERVICE_SUCCESS = 'CHECKOUT_INFO :: CHECK_SERVICE_SUCCESS';

export type TCheckServiceSuccessAction = IReduxAction<typeof CHECK_SERVICE_SUCCESS, ICheckoutInfo>;

export const checkServiceSuccess = actionGenerator<typeof CHECK_SERVICE_SUCCESS, ICheckoutInfo>(CHECK_SERVICE_SUCCESS);
